/*
  NELOW — Libellé « – Rupture de stock » dans les menus Taille de Rapid Bundle.
  Purement visuel : quand Rapid Bundle grise une option de taille (combinaison
  coloris + taille indisponible, ex. motif + 3XL), son texte devient
  « 3XL – Rupture de stock ». Quand l'option redevient disponible, le texte
  d'origine est rétabli automatiquement.
  - Ne modifie jamais la valeur de l'option (attribut value), ni l'état disabled,
    ni la sélection : la logique Rapid Bundle reste seule maître.
  - N'agit que sur les options de taille (M, L, XL, 2XL, 3XL, 4XL, 5XL) qui ont
    un attribut value explicite. Les menus de coloris ne sont jamais modifiés.
  - Le menu garde la largeur qu'il aurait avec les libellés d'origine
    (sinon le libellé long élargirait le menu et décalerait la mise en page).
    La largeur n'est mesurée que lorsque tous les libellés d'origine sont en place
    depuis au moins un instant (le navigateur met à jour la largeur en différé).
  - N'agit que sur les menus de Rapid Bundle (select.rapi-bundles__bar-variant-select).
  - Anti-boucle : l'observateur est déconnecté pendant nos propres modifications,
    il ne réagit donc jamais à ses propres changements.
*/
(function () {
  'use strict';
  var SIZES = ['M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  var SUFFIX = ' – Rupture de stock';
  var SELECTOR = 'select.rapi-bundles__bar-variant-select';
  var OBSERVE = {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled', 'class', 'style']
  };
  var observer = null;
  var retryTimer = null;

  function scheduleRetry() {
    if (retryTimer) return;
    retryTimer = setTimeout(function () {
      retryTimer = null;
      run();
    }, 80);
  }

  // Options de taille du menu (valeur explicite uniquement).
  function sizeOptions(sel) {
    var out = [];
    for (var i = 0; i < sel.options.length; i++) {
      var o = sel.options[i];
      var v = o.getAttribute('value');
      if (v !== null && SIZES.indexOf(v) !== -1) out.push(o);
    }
    return out;
  }

  function resetSelect(sel, opts) {
    for (var i = 0; i < opts.length; i++) {
      var v = opts[i].getAttribute('value');
      if (opts[i].text !== v) opts[i].text = v;
    }
    if (sel.hasAttribute('data-nlw-w')) sel.removeAttribute('data-nlw-w');
    if (sel.style.width) sel.style.width = '';
  }

  function updateSelect(sel) {
    var opts = sizeOptions(sel);
    if (!opts.length) return;

    var anyDisabled = false;
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].disabled) { anyDisabled = true; break; }
    }

    if (!anyDisabled) {
      resetSelect(sel, opts);
      return;
    }

    // Au moins une taille grisée : il faut d'abord connaître la largeur « d'origine ».
    if (!sel.hasAttribute('data-nlw-w')) {
      var modified = false;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j].text !== opts[j].getAttribute('value')) { modified = true; break; }
      }
      if (modified || sel.style.width) {
        // Revenir à l'état d'origine, puis mesurer un peu plus tard.
        resetSelect(sel, opts);
        scheduleRetry();
        return;
      }
      var w = sel.getBoundingClientRect().width;
      if (!(w > 0)) return; // menu masqué : libellés courts en attendant qu'il soit visible
      sel.setAttribute('data-nlw-w', String(w));
    }
    var wanted = sel.getAttribute('data-nlw-w') + 'px';
    if (sel.style.width !== wanted) sel.style.width = wanted;

    for (var k = 0; k < opts.length; k++) {
      var val = opts[k].getAttribute('value');
      var label = opts[k].disabled ? val + SUFFIX : val;
      if (opts[k].text !== label) opts[k].text = label;
    }
  }

  function run() {
    if (observer) observer.disconnect();
    try {
      var sels = document.querySelectorAll(SELECTOR);
      for (var s = 0; s < sels.length; s++) updateSelect(sels[s]);
    } finally {
      if (observer) observer.observe(document.body, OBSERVE);
    }
  }

  function start() {
    observer = new MutationObserver(run);
    run();
    // Changement de taille d'écran (rotation…) : on revient à l'état d'origine puis on remesure.
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (observer) observer.disconnect();
        var sels = document.querySelectorAll(SELECTOR);
        for (var i = 0; i < sels.length; i++) resetSelect(sels[i], sizeOptions(sels[i]));
        if (observer) observer.observe(document.body, OBSERVE);
        scheduleRetry();
      }, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
